import awaitToJs from 'await-to-js'
import Fetch from '@App/helpers/fetch'
import {
  ALERT_COLORS,
  LOGIN_ROUTE, MESSAGE_ERROR,
  RESET_PASSWORD_SUCCESS,
  ALERT_DELAY,
} from '@App/constantes'
import { API_URL } from '@App/configs/rest'
import { setAlertBox } from './snackbar'
import history from '@App/helpers/history'

const fetchGetCreatePassword = new Fetch()

export const getCreatePassword = ({ token = '', password = '' }: any) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(fetchGetCreatePassword.post({
      url: `${API_URL}/users/auth/reset-password`,
      body: {
        password,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        'content-type': 'application/json',
      },
    }))

    if (!err) {
      history.push(LOGIN_ROUTE)

      dispatch(setAlertBox({
        title: data && data.message || RESET_PASSWORD_SUCCESS,
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }))

      return data
    }

    if (err) {
      dispatch(setAlertBox({
        title: err && err.message || MESSAGE_ERROR,
        background: ALERT_COLORS.red,
        delay: ALERT_DELAY,
      }))

      throw err
    }

    return new Error('Error')
  }
}
